// src/components/Button.js
import React, { useContext } from 'react';
import styled from 'styled-components';
import ThemeContext from '../context/ThemeContext'; // Import your custom ThemeContext

// Styled Button component with direct access to theme values
const StyledButton = styled.button`
  width: ${({ width }) => width || 'auto'};
  padding: ${({ padding }) => padding || '10px 20px'};
  background-color: ${({ theme }) => theme.mainAccent};
  color: ${({ color }) => color || 'white'};
  border: none;
  border-radius: ${({ borderRadius }) => borderRadius || '4px'};
  font-size: ${({ fontSize }) => fontSize || '16px'};
  cursor: pointer;
  margin: ${({ margin }) => margin || '0'};
  transition: background-color 0.3s ease;

  // Use theme.offAccent directly for hoverColor
  &:hover {
    background-color: ${({ theme }) => theme.mainOff};
  }
`;

// Button component definition
const Button = ({ children, width, padding, color, borderRadius, fontSize, margin, ...props }) => {
  // Access the custom theme context (optional: use styledTheme if needed)
  const { theme } = useContext(ThemeContext); // Your custom theme context

  return (
    <StyledButton
      width={width}
      padding={padding}
      color={color}
      borderRadius={borderRadius}
      fontSize={fontSize}
      margin={margin}
      theme={theme} // Pass theme to StyledButton
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
